import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductTransactions16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_423)'>
      <path d='M6 5.25V6.75H10V5.25H6Z' fill='currentColor' />
      <path d='M6 4.25V2.75H10V4.25H6Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 0.25C3.7087 0.25 0.25 3.78072 0.25 8.11111C0.25 12.4415 3.7087 15.9722 8 15.9722C12.2913 15.9722 15.75 12.4415 15.75 8.11111C15.75 3.78072 12.2913 0.25 8 0.25ZM4.75 2.67703C5.69812 2.08855 6.81139 1.75 8 1.75C9.18861 1.75 10.3019 2.08855 11.25 2.67703V9.64682L8.6625 8.02963C8.25716 7.77629 7.74284 7.77629 7.3375 8.02963L4.75 9.64682V2.67703ZM3.25 3.97652C2.31558 5.08687 1.75 6.52978 1.75 8.11111C1.75 11.6354 4.55931 14.4722 8 14.4722C11.4407 14.4722 14.25 11.6354 14.25 8.11111C14.25 6.52978 13.6844 5.08687 12.75 3.97652V10.0979C12.75 11.0797 11.6701 11.6782 10.8375 11.1579L8 9.38444L5.1625 11.1579C4.32994 11.6782 3.25 11.0797 3.25 10.0979V3.97652Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_423'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductTransactions16.displayName = 'ProductTransactions16';
export default ProductTransactions16;
